import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { ShortcutMenu } from '@/plugins/shortcut-menu/shortcut-menu';
import { PluginType, type IExportPlugin } from '@/version-types';
import { chartEditDataShortcutItem } from './chart-edit-data-item';

const ChartLayerShortcutMenuView: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);

        framework.service.registration.getInstance<ShortcutMenu>('ShortcutMenu').addItems([
            {
                key: 'chart-edit-data-30',
                sort: 30,
                render: chartEditDataShortcutItem,
            },
        ]);
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'chart-layer-shortcut-menu',
    render() {
        return <ChartLayerShortcutMenuView />;
    },
};

export default exportPlugin;
